import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { DocumentoService } from '@app/services/documento.service';
import { Documento } from '@app/models/documento.model';

@Component({
  selector: 'app-documento-form',
  templateUrl: './documento-form.component.html'
})
export class DocumentoFormComponent implements OnInit {

  aguardandoSolicitacao : boolean = false;
  titulo: string;
  lstErros: string[];
  documento: Documento = new Documento();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private documentoService: DocumentoService) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      const id = params['id'];
      this.titulo = id ? 'Editar Documento' : 'Novo Documento';

      if (!id) {
        return;
      }

      this.documentoService.obterPorId(id).toPromise().then(
        data => this.documento = data,
        () => this.router.navigate(['./configuracoes/documento']));
    });
  }

  onSubmit() {
    this.aguardandoSolicitacao = true;
    this.documentoService.gravar(this.documento).toPromise().then(
      () => this.router.navigate(['./configuracoes/documento']),
      (data: any) => {
        if (data.error) {
          this.lstErros = data.error.errors;
        }
        this.aguardandoSolicitacao = false;
      });
  }
}
